export var ExportColumnKey;
(function (ExportColumnKey) {
    ExportColumnKey["DATE"] = "date";
    ExportColumnKey["CUSTOM_ID"] = "custom_id";
    ExportColumnKey["VIN"] = "vin";
    ExportColumnKey["BRAND"] = "brand";
    ExportColumnKey["MODEL"] = "model";
    ExportColumnKey["VARIANT"] = "variant";
    ExportColumnKey["TITLE"] = "title";
    ExportColumnKey["MILEAGE"] = "mileage";
    ExportColumnKey["REGISTRATION"] = "registration";
    ExportColumnKey["POWER"] = "power";
    ExportColumnKey["FUEL"] = "fuel";
    ExportColumnKey["TRANSMISSION"] = "transmission";
    ExportColumnKey["VEHICLE_TYPE"] = "vehicleType";
    ExportColumnKey["TAXATION"] = "taxation";
    ExportColumnKey["PRICE"] = "price";
    ExportColumnKey["RANGE_MIN"] = "range_min";
    ExportColumnKey["RANGE_MAX"] = "range_max";
    ExportColumnKey["PRICE_RANGE"] = "price_range";
    ExportColumnKey["MEDIAN"] = "median";
    ExportColumnKey["HEK"] = "hek";
    ExportColumnKey["RESULT_COUNT"] = "result_count";
    ExportColumnKey["LINK"] = "link";
    ExportColumnKey["DEALER_NAME"] = "dealerName";
    ExportColumnKey["DEALER_LOCATION"] = "dealerLocation";
    ExportColumnKey["DETAIL_URL"] = "detailUrl";
    ExportColumnKey["PRICE_RATING"] = "priceRating";
})(ExportColumnKey || (ExportColumnKey = {}));
//# sourceMappingURL=export.js.map